// stores/alertStore.js
import { create } from 'zustand';

const useAlertStore = create((set) => ({
  isOpen: false,
  title: '',
  message: '',
  resolveCallback: null,

  openAlert: (title, message) => {
    return new Promise((resolve) => {
      set({ isOpen: true, title, message, resolveCallback: resolve });
    });
  },

  closeAlert: () => {
    set({ isOpen: false, title: '', message: '', resolveCallback: null });
  },
}));

export default useAlertStore;